import type Vue from 'vue';
import { resolveInjected } from '~/utils/nuxt-instance';

/** HTML sanitizer (`sanitize-html`) injected by plugins/sanitizer.js. */
export function useSanitize(): Vue['$sanitize'] {
  return resolveInjected('$sanitize');
}
